<div
  *ngIf="availableTimes$ | async as availableTimes"
  fxLayout="row wrap"
  fxLayoutAlign="center none"
  fxLayoutGap="10px"
  class="day-times-picker"
>
  <div
    *ngFor="let weekday of weekdays"
    fxFlex="13"
    fxFlex.md="18"
    fxFlex.sm="30"
    fxFlex.xs="100"
    [ngClass]="{
      'weekday': true,
      'disabled': !availableTimes[weekday.value].length,
      'active': isWeekdaySelected(weekday.value)
    }"
  >
    <div class="time-select-header">
      <div class="weekday-name">
        {{ weekday.label | translate }}
      </div>
    </div>

    <ul *ngIf="availableTimes[weekday.value].length; else closedEl" class="times-list">
      <li *ngFor="let time of availableTimes[weekday.value]">
        <button
          matRipple
          matRippleColor="rgba(255,255,255,0.3)"
          [ngClass]="{ 'active': isTimeSelected(weekday.value, time.value) }"
          [value]="time.value"
          [disabled]="time.isDisabled"
          (click)="onTimePicked({ weekday, time })"
        >
          {{ time.label | translate }}
        </button>
      </li>
    </ul>

    <ng-template #closedEl>
      <div class="closed-container">
        <mat-icon>error_outline</mat-icon>
        <div>
          {{ 'availability-picker.times.closed' | translate }}
        </div>
      </div>
    </ng-template>
  </div>
</div>
